import { renameKeysFromRESTResponseToSDKResponse } from '@wix/sdk-runtime/rename-all-nested-keys';
import { transformRESTFloatToSDKFloat } from '@wix/sdk-runtime/transformations/float';
import { transformRESTTimestampToSDKTimestamp } from '@wix/sdk-runtime/transformations/timestamp';
import { transformPaths } from '@wix/sdk-runtime/transformations/transform-paths';
import { EventDefinition, HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  AbandonedCart,
  AbandonedCartCartAbandonedEnvelope,
  AbandonedCartCartRecoveredEnvelope,
  QueryAbandonedCartsOptions,
  QueryAbandonedCartsResponse,
  getAbandonedCart as universalGetAbandonedCart,
  queryAbandonedCarts as universalQueryAbandonedCarts,
} from './stores-v1-abandoned-cart-abandoned-carts.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/stores' };

/** @internal */
export function getAbandonedCart(
  httpClient: HttpClient
): GetAbandonedCartSignature {
  return (_id: string) =>
    universalGetAbandonedCart(
      _id,
      // @ts-ignore
      { httpClient }
    );
}

interface GetAbandonedCartSignature {
  /**
   * Returns abandoned carts based on the cart ID
   * @param - Cart ID
   * @returns Cart details
   * @deprecated
   */
  (_id: string): Promise<
    NonNullablePaths<
      AbandonedCart,
      | `_id`
      | `status`
      | `buyerInfo._id`
      | `buyerInfo.identityType`
      | `activities`
      | `activities.${number}.activityType`,
      4
    >
  >;
}

/** @internal */
export function queryAbandonedCarts(
  httpClient: HttpClient
): QueryAbandonedCartsSignature {
  return (options?: QueryAbandonedCartsOptions) =>
    universalQueryAbandonedCarts(
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface QueryAbandonedCartsSignature {
  /**
   * Returns abandoned carts based on the requested query parameters
   * @deprecated
   */
  (options?: QueryAbandonedCartsOptions): Promise<
    NonNullablePaths<
      QueryAbandonedCartsResponse,
      | `abandonedCarts`
      | `abandonedCarts.${number}._id`
      | `abandonedCarts.${number}.status`
      | `abandonedCarts.${number}.buyerInfo._id`
      | `abandonedCarts.${number}.buyerInfo.identityType`
      | `totalResults`,
      5
    >
  >;
}

export const onAbandonedCartCartAbandonedEvent = EventDefinition(
  'com.wix.ecommerce.cart.abandonment.api.v1.CartAbandonedEvent',
  false,
  (event: AbandonedCartCartAbandonedEnvelope) =>
    renameKeysFromRESTResponseToSDKResponse(
      transformPaths(event, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [{ path: 'data.creationTime' }, { path: 'data.abandonTime' }],
        },
        {
          transformFn: transformRESTFloatToSDKFloat,
          paths: [
            { path: 'data.totals.subtotal' },
            { path: 'data.totals.total' },
          ],
        },
      ])
    )
)<AbandonedCartCartAbandonedEnvelope>();
export const onAbandonedCartCartRecoveredEvent = EventDefinition(
  'com.wix.ecommerce.cart.abandonment.api.v1.CartRecoveredEvent',
  false,
  (event: AbandonedCartCartRecoveredEnvelope) =>
    renameKeysFromRESTResponseToSDKResponse(
      transformPaths(event, [
        {
          transformFn: transformRESTTimestampToSDKTimestamp,
          paths: [
            { path: 'data.recoveredTime' },
            { path: 'data.creationTime' },
            { path: 'data.abandonedTime' },
          ],
        },
      ])
    )
)<AbandonedCartCartRecoveredEnvelope>();

export {
  AbandonedCart,
  AbandonedCartCartAbandonedEnvelope,
  AbandonedCartCartRecoveredEnvelope,
  AccountInfo,
  Activity,
  ActivityType,
  BaseEventMetadata,
  BuyerInfo,
  CartAbandonedEvent,
  CartDeletedEvent,
  CartRecoveredEvent,
  CustomData,
  DeleteCartRequest,
  DeleteCartResponse,
  GetAbandonedCartRequest,
  GetAbandonedCartResponse,
  HeadersEntry,
  IdentificationData,
  IdentificationDataIdOneOf,
  Identity,
  MessageEnvelope,
  Paging,
  Query,
  QueryAbandonedCartsOptions,
  QueryAbandonedCartsRequest,
  QueryAbandonedCartsResponse,
  RawHttpResponse,
  RedirectToCheckoutRequest,
  Status,
  Totals,
  WebhookIdentityType,
} from './stores-v1-abandoned-cart-abandoned-carts.universal.js';
